import React, {
  createContext,
  useMemo,
  useState,
  useContext,
  useEffect,
} from 'react';
import api from '~/services/api';
import { toast } from 'react-hot-toast';
import { useAuth } from '../AuthContext';

const ClubeContext = createContext();

const ClubeProvider = ({ children }) => {
  const [sessionsAwarded, setSessionsAwarded] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:sessionsAwarded')) || []
  );
  const [rescues, setRescues] = useState(
    JSON.parse(localStorage.getItem('@gddashboard:rescues')) || []
  );
  const { user } = useAuth();

  const [loadingPontuarSession, setLoadingPontuarSession] = useState(false);

  async function handlePontuarSession({ session_key }) {
    setLoadingPontuarSession(true);
    if (user.has_clube) {
      try {
        const response = await api.post('public/clube/send/session', {
          session_key,
          rescues,
        });

        toast.success('Clientes pontuados!');
        setSessionsAwarded((state) => {
          return [...state, response.data.id];
        });
        const phoneNumbersOnSession = [
          response.data.client?.phone,
          ...response.data.bills
            ?.map((bill) => {
              if (bill.buyer?.phone) {
                return bill.buyer?.phone;
              }
              return;
            })
            .filter((phone) => !!phone),
        ];

        setRescues((state) =>
          state.filter(
            (rescue) => !phoneNumbersOnSession.includes(rescue.phone)
          )
        );
      } catch (error) {
        toast.error(error?.response?.data?.error || 'Não foi possível pontuar essa sessão. Tente novamente');
      }
    }
    setLoadingPontuarSession(false);
  }

  async function saveSendedSession(response) {
    if (user.has_clube) {
      try {
        if(!response.error){
          setSessionsAwarded((state) => {
            return [...state, response.id];
          });
  
          const phoneNumbersOnSession = [
            response.client?.phone,
            ...response.bills
              ?.map((bill) => {
                if (bill.buyer?.phone) {
                  return bill.buyer?.phone;
                }
                return;
              })
              .filter((phone) => !!phone),
          ];
  
          setRescues((state) =>
            state.filter(
              (rescue) => !phoneNumbersOnSession.includes(rescue.phone)
            )
          );
        }
      } catch (error) {
        console.log('erro clube > ', error);
        toast.error('Erro ao atualizar informações do clube');
      }
    }
  }

  useEffect(() => {
    localStorage.setItem('@gddashboard:rescues', JSON.stringify(rescues));
  }, [rescues]);

  useEffect(() => {
    localStorage.setItem(
      '@gddashboard:sessionsAwarded',
      JSON.stringify(sessionsAwarded)
    );
  }, [sessionsAwarded]);

  const value = useMemo(
    () => ({
      sessionsAwarded,
      setSessionsAwarded,
      handlePontuarSession,
      rescues,
      setRescues,
      loadingPontuarSession,
      saveSendedSession
    }),
    [
      sessionsAwarded,
      setSessionsAwarded,
      handlePontuarSession,
      rescues,
      setRescues,
      loadingPontuarSession,
      saveSendedSession
    ]
  );
  return (
    <ClubeContext.Provider value={value}>{children}</ClubeContext.Provider>
  );
};

function useClube() {
  const context = useContext(ClubeContext);

  if (!context) {
    throw new Error('useClube must be used within an ClubeProvider');
  }

  return context;
}

export { useClube, ClubeProvider };
